import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutManualOfficeSettlementList extends Layout {
    buttonPrintPost: Button;
    layoutheaderTitle: LayoutHeader;
    sourceManualOfficeSettlementList: DataSource;
    tableManualOfficeSettlementList: Table;
}
